//TODO: Remove the unused interfaces after hooking up with backend data

export interface Option {
    id: number | string;
    name: string | number;
}

//TODO: Remove the unused interfaces after hooking up with backend data

enum ModalForm {
    ADD_CARRIER = 'addCarrier',
    EDIT_CARRIER = 'editCarrier',
    EMPTY = '',
}
export { ModalForm };
